import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('PlatinumOffer').create(({ theme }) => ({
  root: {
    width: '100%',
    height: '84px',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    flexDirection: 'column',
    background: '#17181B',
    borderRadius: '8px',
    border: '1px solid',
    borderColor: 'rgba(255, 228, 28, 1)',
    boxShadow: '0px 0px 6px rgba(255, 241, 156, 1)',
    cursor: 'pointer',

    '&[data-isselected="true"]': {
      border: '1px solid white',
    },
    '&[data-variant="platinumDiscount"]': {
      border: '1px solid #FFE41C',
      background:
        'linear-gradient(0deg, #17181B 0%, #17181B 100%), linear-gradient(131deg, #FFE41C -2.34%, #FFC926 25.61%, #FFF5A9 39.84%, #FFBF40 54.61%, #FFF5A9 63.05%, #FFE626 103.12%)',
    },
  },

  rootWrapper: {
    background: 'rgba(176, 177, 184, 0.12)',
    border: '1px solid',
    borderRadius: '8px',
    padding: '6px',
    borderColor: 'rgba(255, 255, 255, 0.09)',
  },

  radioWrapper: {
    position: 'absolute',
    padding: '8px',
    right: '0%',
    top: '0%',
  },

  iconsContainer: {
    display: 'flex',
    gap: '4px',
  },

  bottomContainer: {
    display: 'flex',
    gap: '4px',

    span: {
      fontSize: theme.sizes.texts.fontSize.s,
      fontWeight: 350,
      color: theme.colors.text.primary,
    },
  },
}))
